/** Display labels for all boat kind keys (MMK browse + DB normalized). */
export const KIND_LABELS: Record<string, string> = {
  // MMK browse keys
  sailboat: 'Sailing Yacht',
  catamaran: 'Catamaran',
  motoryacht: 'Motor Yacht',
  gulet: 'Gulet',
  motorboat: 'Motorboat',
  motorsailer: 'Motor Sailer',
  powercatamaran: 'Power Cat',
  trimaran: 'Trimaran',
  houseboat: 'Houseboat',
  // DB normalized keys
  sailing_yacht: 'Sailing Yacht',
  motor_yacht: 'Motor Yacht',
  motor_sailer: 'Motor Sailer',
  power_catamaran: 'Power Cat',
};

/** Badge color classes per kind. */
export const KIND_BADGE_CLASSES: Record<string, string> = {
  sailboat:
    'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300',
  catamaran:
    'border-teal-200 bg-teal-50 text-teal-700 dark:border-teal-800 dark:bg-teal-950 dark:text-teal-300',
  motoryacht:
    'border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-800 dark:bg-purple-950 dark:text-purple-300',
  gulet:
    'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300',
  motorboat:
    'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-800 dark:bg-rose-950 dark:text-rose-300',
  motorsailer:
    'border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-800 dark:bg-indigo-950 dark:text-indigo-300',
  powercatamaran:
    'border-cyan-200 bg-cyan-50 text-cyan-700 dark:border-cyan-800 dark:bg-cyan-950 dark:text-cyan-300',
  trimaran:
    'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  houseboat:
    'border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-800 dark:bg-orange-950 dark:text-orange-300',
  sailing_yacht:
    'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300',
  motor_yacht:
    'border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-800 dark:bg-purple-950 dark:text-purple-300',
  motor_sailer:
    'border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-800 dark:bg-indigo-950 dark:text-indigo-300',
  power_catamaran:
    'border-cyan-200 bg-cyan-50 text-cyan-700 dark:border-cyan-800 dark:bg-cyan-950 dark:text-cyan-300',
};
